import { defineMessages } from 'react-intl';

export const GlobalMessages = defineMessages({
  appName: {
    id: 'global.appName',
    defaultMessage: 'Estimator',
  },
  initializatingSystem: {
    id: 'global.initializatingSystem',
    defaultMessage: 'Initializing system, please wait',
  },
  signInFailed: {
    id: 'global.signInFailed',
    defaultMessage: 'Sign-in failed. Please try again, or contact support if this keeps happening.',
  },
  signInRetry: {
    id: 'global.signInRetry',
    defaultMessage: 'Try again',
  },
  // EWM-1066: shown instead of the sign-in-failed retry when the account itself cannot be
  // provisioned. Deliberately offers no retry - the token will keep arriving incomplete until the
  // IdP / B2C claim mapping is fixed, so retrying just re-runs the lockout.
  provisioningBlocked: {
    id: 'global.provisioningBlocked',
    defaultMessage:
      'Your account could not be set up because your sign-in is missing required information. Please contact your administrator or support with the reference below.',
  },
  // EWM-1165: long-inactive early users previously saw a silent 401 / naked 404. Point them at
  // the B2C "Forgot your password?" path (and admin resend-invite) instead of only "Try again".
  resetPasswordOrResendInvite: {
    id: 'global.resetPasswordOrResendInvite',
    defaultMessage: 'Reset your password / ask your admin to resend the invite',
  },
  signOut: {
    id: 'global.signOut',
    defaultMessage: 'Sign out',
  },
  continueEstimationOf: {
    id: 'global.continueEstimationOf',
    defaultMessage: 'Continue estimation of',
  },
  continueEstimation: {
    id: 'global.continueEstimation',
    defaultMessage: 'Continue estimation',
  },
  saveAllChanges: {
    id: 'global.saveAllChanges',
    defaultMessage: 'Save all changes',
  },
  saveAndClose: {
    id: 'global.saveAndClose',
    defaultMessage: 'Save and close',
  },
  save: {
    id: 'global.save',
    defaultMessage: 'Save',
  },
  create: {
    id: 'global.create',
    defaultMessage: 'Create',
  },
  close: {
    id: 'global.close',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'global.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'global.delete',
    defaultMessage: 'Delete',
  },
  confirm: {
    id: 'global.confirm',
    defaultMessage: 'Confirm',
  },
  copy: {
    id: 'global.copy',
    defaultMessage: 'Copy',
  },
  publish: {
    id: 'global.publish',
    defaultMessage: 'Publish',
  },
  paginationText: {
    id: 'global.paginationText',
    defaultMessage: '`Showing  {from} to {to} of {totalCount} entries`',
  },
  loading: {
    id: 'global.loading',
    defaultMessage: 'Loading...',
  },
  saving: {
    id: 'global.saving',
    defaultMessage: 'Saving...',
  },
  noDataFound: {
    id: 'global.NoDataFound',
    defaultMessage: 'No data found',
  },
  noTenantsFound: {
    id: 'global.NoTenantsFound',
    defaultMessage: 'No tenants found',
  },
  search: {
    id: 'global.search',
    defaultMessage: 'Search Term...',
  },
  status: {
    id: 'global.status',
    defaultMessage: 'Status',
  },
  numberOfUsers: {
    id: 'global.noOfUsers',
    defaultMessage: 'Number of Users',
  },
  createdAt: {
    id: 'global.createdAt',
    defaultMessage: 'Created At',
  },
  tablePaginationMessage: {
    id: 'table.pagination.message',
    defaultMessage: 'Showing {from} to {to} of {totalRecords} entries',
  },
  yes: {
    id: 'global.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'global.no',
    defaultMessage: 'No',
  },
  notNow: {
    id: 'global.search',
    defaultMessage: 'Not now',
  },
  prevStep: {
    id: 'global.prevStep',
    defaultMessage: 'Previous step',
  },
  nextStep: {
    id: 'global.nextStep',
    defaultMessage: 'Next step',
  },
  export: {
    id: 'global.export',
    defaultMessage: 'Export',
  },
  notAvailable: {
    id: 'global.notAvailable',
    defaultMessage: 'N/A',
  },
  areYouSureYouWantToProceed: {
    id: 'global.areYouSureYouWantToProceed',
    defaultMessage: 'Are you sure you want to proceed?',
  },
  columns: {
    id: 'global.columns',
    defaultMessage: 'Columns',
  },

  selectLanguage: {
    id: 'global.selectLanguage',
    defaultMessage: 'Select language',
  },

  unexpectedError: {
    id: 'global.unexpectedError',
    defaultMessage: 'Unexpected error occurs. Please contact support.',
  },

  chooseDate: {
    id: 'global.chooseDate',
    defaultMessage: 'Choose date',
  },
  savedSuccessfully: {
    id: 'global.savedSuccessfully',
    defaultMessage: 'Changes have been successfully saved.',
  },
  emptyContext: {
    id: 'global.emptyContext',
    defaultMessage: 'No data found, redirecting to the first step of wizard.',
  },
  tenantStylesNotLoaded: {
    id: 'global.tenantStylesNotLoaded',
    defaultMessage: 'Tenant styles failed to load.',
  },
  inactive: {
    id: 'global.inactive',
    defaultMessage: 'INACTIVE',
  },
  next: {
    id: 'global.next',
    defaultMessage: 'Next',
  },
  finish: {
    id: 'global.finish',
    defaultMessage: 'Finish',
  },
  back: {
    id: 'global.back',
    defaultMessage: 'Back',
  },
  filter: {
    id: 'global.filter',
    defaultMessage: 'Filter',
  },
  applyFilters: {
    id: 'global.applyFilters',
    defaultMessage: 'Apply filters',
  },
  select: {
    id: 'global.select',
    defaultMessage: 'Select...',
  },
  estimation: {
    id: 'global.estimation',
    defaultMessage: 'Estimation',
  },
});
